import { createSelector } from 'reselect';

import { selectCurrentOrganizationOptions } from '../../selectors/organizations';

export const selectIsCsOrgSettingsResolved = createSelector(selectCurrentOrganizationOptions, Boolean);
